/**
 * Stable CSS class names for E2E — Cron dialog wrapper.
 */
export const CROND = {
    root: 'cron-dialog',
    previewRow: 'cron-dialog__preview-row',
    previewText: 'cron-dialog__preview-text',
    openButton: 'cron-dialog-input--button-open',
    openIcon: 'cron-dialog__open-icon',

    descriptionText: 'cron-dialog__description-text',

    dialog: 'cron-dialog__dialog',
    dialogTitle: 'cron-dialog__dialog-title',
    dialogCloseButton: 'cron-dialog-input--button-close',
    dialogCloseIcon: 'cron-dialog__dialog-close-icon',
    dialogContent: 'cron-dialog__dialog-content',

    previewBox: 'cron-dialog__preview-box',
    previewBoxTitle: 'cron-dialog__preview-box-title',
    previewBoxText: 'cron-dialog__preview-box-text',

    actions: 'cron-dialog__actions',
    cancelButton: 'cron-dialog-input--button-cancel',
    saveButton: 'cron-dialog-input--button-save',
} as const;

export const crondCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

